<template>
    <div class="common-form-inline page-main no-shadow">
        <a-form-model
        ref="recommendForm"
        layout="inline"
        :model="pageData"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        >
            <a-form-model-item label="社会信用代码" prop="cstOrgCode" style="width:40%;margin-bottom:15px;">
                <a-input v-model="pageData.cstOrgCode" @blur="getUserInfo"/>
            </a-form-model-item>
            <a-form-model-item label="企业名称" prop="cstNm" style="width:40%;margin-bottom:15px;">
                <a-input v-model="pageData.cstNm" :disabled="hasInfo"/>
            </a-form-model-item>
             <a-form-model-item label="联系人" prop="contactPerson" style="width:40%;margin-bottom:15px;">
                <a-input v-model="pageData.contactPerson"/>
            </a-form-model-item>
            <a-form-model-item label="联系电话" prop="ctcPsnTel" style="width:40%;margin-bottom:15px;">
                <a-input v-model="pageData.ctcPsnTel"/>
            </a-form-model-item>
            <a-form-model-item label="角色" prop="roleCd" style="width:40%;margin-bottom:15px;">
                <a-checkbox-group v-model="pageData.roleCd">
                    <a-checkbox v-for="item in roleCdOptions" :key="item.key" :value="item.key" name="roleCode" :checked="item.checked" >
                        {{item.text}}
                    </a-checkbox>
                </a-checkbox-group>
            </a-form-model-item>
            <!-- <a-form-model-item label="保理商" prop="tenantId" style="width:40%;margin-bottom:15px;">
                <a-select v-model="pageData.tenantId" style="width:100%;">
                    <a-select-option v-for="item in tenantList" :key="item.tenantId" :value="item.tenantId">{{item.tenantName}}</a-select-option>
                </a-select>
            </a-form-model-item> -->
        </a-form-model>
        <div class="model-footer-btns spaceCenter">
            <a-button class="btn-blue-line" @click="goback">返回</a-button>
            <a-button type="primary" @click="submit">推荐</a-button>
        </div>
    </div>
</template>

<script>
import { circleGet,circleUserInfo,circleAdd } from "@/api/circle.js"
import { selectTenant } from "@/api/login.js"
export default {
    name:"recommendMain",
    components: {},
    data() {
        return {
            pageData:{
                cstOrgCode:"",
                cstNm:"",
                contactPerson:"",
                ctcPsnTel:"",
                roleCd:[],
                tenantId:this.$store.getters["home/getTenant"].tenantId,
            },
            labelCol: { span: 8 },
            wrapperCol: { span: 16 },
            rules:{
                cstOrgCode: [
                    {
                        required: true,
                        trigger: "blur",
                        whitespace:true,
                        validator: (rule, value, cbfn) => {
                            if (!value) {
                                cbfn('请填写社会信用代码');
                            } else if (!this.utils.creditCode(value)) {
                                cbfn('不是有效的统一社会信用编码');
                            }
                            cbfn();
                        }
                    }
                ],
                cstNm: [
                    {
                        required: true,
                        message: "请填写企业名称",
                        trigger: "blur",
                        whitespace:true
                    }
                ],
                contactPerson: [
                    {
                        required: true,
                        message: "请填写联系人",
                        trigger: "blur",
                        whitespace:true
                    }
                ],
                ctcPsnTel: [
                    {
                        required: true,
                        trigger: "blur",
                        whitespace:true,
                        validator: (rule, value, cbfn) => {
                            if (!value) {
                                cbfn('请填写联系电话');
                            } else if (!this.utils.regExpObj.MOBILE_PATTERN.test(value)) {
                                cbfn('输入手机号格式不正确');
                            }
                            cbfn();
                        }
                    }
                ],
                roleCd: [
                    {
                        type:"array",
                        required: true,
                        message: "请选择角色",
                        trigger: "change",
                        whitespace:true
                    }
                ],
                // tenantId: [
                //     {
                //         required: true,
                //         message: "请选择保理商",
                //         trigger: "change",
                //         whitespace:true
                //     }
                // ],
            },
            roleCdOptions:[
                {
                    key: '1',
                    text: '上游客户',
                    checked: false
                }, {
                    key: '0',
                    text: '下游客户',
                    checked: false
                }
            ],
            tenantList:[],
            hasInfo:false
        };
    },
    computed: {},
    methods: {
        pageInit(){
            circleGet()
            .then(res => {

            })
            .catch(err => {
                console.log(err);
            })
        },
        getSelectTenant(){
            selectTenant()
            .then(res => {
                this.tenantList = res.data.grid.list||[];
            })
            .catch(err => {
                console.log(err);
            })
        },
        getUserInfo(){
            if(!this.pageData.cstOrgCode){
                return ;
            }
            const param = {
                orgCode:this.pageData.cstOrgCode
            };
            let self = this;
            this.axios({
                url:"/user/circle/userInfo",
                data:param,
                success:(res) => {
                    if(res.data && res.data.userName){
                        self.pageData.cstNm = res.data.userName;
                        self.hasInfo = true;
                    }else{
                        self.pageData.cstNm = "";
                        self.hasInfo = false;
                    }
                },
                fail:(err) => {
                    self.pageData.cstNm = "";
                    self.hasInfo = false;
                }
            })
        },
        submit(){
            this.$refs.recommendForm.validate((valid) => {
                if (valid) {
                    const param = {
                        cstNm: this.pageData.cstNm,
                        cstOrgCode: this.pageData.cstOrgCode,
                        contactPerson: this.pageData.contactPerson,
                        ctcPsnTel: this.pageData.ctcPsnTel,
                        roleCd: this.pageData.roleCd.join(","),
                        tenantId:this.pageData.tenantId,
                    }
                    circleAdd(param,true)
                    .then(res => {
                        this.$message.success("已成功推荐，请联系平台发送邀请码");
                        this.goback();
                    })
                    .ctach(err => {
                        console.log(err);
                    })
                } else {
                    return false;
                }
            });
        },
        goback(){
            this.$router.go(-1);
        }
    },
    created() {
        this.pageInit();
        this.getSelectTenant();
    },
    mounted() {},
    activated() {},
    watch: {},
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/account/circle/recommend/recommend-main.vue